import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ContentLayoutComponent} from './content-layout/content-layout.component';
import {HeaderComponent} from './header/header.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {SharedModule} from '../shared/shared.module';
import {MatMenuModule} from '@angular/material/menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {FooterComponent} from './footer/footer.component';
import {SidenavMobileComponent} from './sidenav-mobile/sidenav-mobile.component';
import {SidenavDesktopComponent} from './sidenav-desktop/sidenav-desktop.component';


@NgModule({
	declarations: [ContentLayoutComponent, HeaderComponent, FooterComponent, SidenavMobileComponent, SidenavDesktopComponent],
	exports: [
		ContentLayoutComponent
	],
	imports: [
		SharedModule,
		CommonModule,
		RouterModule,
		MatToolbarModule,
		MatMenuModule,
		MatSidenavModule,
		MatListModule
	]
})
export class LayoutModule {
}
